import {Skeleton, Stack} from '@mui/material';

const IdentityInformationSkeleton = () => {
    return (
        <>
            <div className="pt-20 centerClassMaxWith">
                <Stack spacing={2}>
                    <Skeleton variant="rounded" height={'83px'} />
                    <Skeleton variant="rounded" height={'83px'} />
                    <Skeleton variant="rounded" height={'83px'} />
                    <Skeleton variant="rounded" height={'83px'} />
                </Stack>
            </div>
        </>
    );
};

export default IdentityInformationSkeleton;
